import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Gauge, MapPin, Zap } from "lucide-react";

const RESULT_STYLE = {
  win: { bar: "#2DB45D", label: "WIN", chip: "bg-[#2DB45D] text-white" },
  loss: { bar: "#1A1A1E", label: "LOSS", chip: "bg-mt-text text-white" },
  bye: { bar: "#F0A500", label: "BYE", chip: "bg-mt-accent text-mt-text" },
  "": { bar: "#D4D0C4", label: "LOGGED", chip: "bg-mt-secondary text-mt-text" },
};

export function RunCard({ run, index = 0 }) {
  const navigate = useNavigate();
  const style = RESULT_STYLE[run.result || ""] || RESULT_STYLE[""];
  return (
    <motion.button
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.04 }}
      whileHover={{ y: -2 }}
      onClick={() => navigate(`/run/${run.id}`)}
      data-testid={`run-card-${run.id}`}
      className="relative flex w-full overflow-hidden rounded-xl border border-mt-border bg-mt-card text-left shadow-sm transition-colors hover:border-mt-primary"
    >
      <span className="w-1 shrink-0" style={{ backgroundColor: style.bar }} />
      <div className="flex-1 p-4">
        <div className="flex items-start justify-between gap-2">
          <div>
            <div className="flex items-center gap-2 text-mt-text">
              <MapPin size={14} className="text-mt-mutedfg" />
              <span className="font-head text-base font-bold leading-tight">{run.track || "Unknown Track"}</span>
            </div>
            <div className="mt-1 text-xs font-medium text-mt-mutedfg">
              {run.date} · {run.distance} · {run.mode === "race" ? "Race" : "Test & Tune"}
              {run.raceClass ? ` · ${run.raceClass}` : ""}
            </div>
          </div>
          <span className={`rounded-md px-2 py-1 text-[10px] font-bold tracking-widest ${style.chip}`}>{style.label}</span>
        </div>
        <div className="mt-3 grid grid-cols-3 gap-2">
          <Metric icon={Gauge} label="ET" value={run.et || "—"} />
          <Metric icon={Zap} label="MPH" value={run.speed || "—"} />
          <Metric label="R/T" value={run.reactionTime || "—"} />
        </div>
      </div>
    </motion.button>
  );
}

function Metric({ icon: Icon, label, value }) {
  return (
    <div className="rounded-lg bg-mt-secondary/60 px-2 py-1.5">
      <div className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-mt-mutedfg">
        {Icon && <Icon size={11} />} {label}
      </div>
      <div className="font-mono text-sm font-bold text-mt-text">{value}</div>
    </div>
  );
}
